<template>
  <transition name="fade" mode="out-in">
    <li>
      <base-card>
        <header>
          <h3>{{ venuename }}</h3>
          <div class="button-item">
            <base-button mode="flat" @click="selectedResourceTest">
              <b> TAKE THIS SPOT </b>
            </base-button>
          </div>
        </header>

        <!--p>{{ address }}</p-->
        <!--p>{{ address }}</p-->
        <span>Max capacity: {{ maxcapacity }} people</span>
        <p>Start Date/Time: {{ starttime }}</p>

        <p>Finish Date/Time: {{ endtime }}</p>

        <!--nav><a :href="link"> View resources </a></nav-->
      </base-card>
    </li>
  </transition>
</template>

<script>
export default {
  inject: ['selectedResource'],

  emits: ['booking-confirmed'],

  props: [
    'venuename',
    'id',
    'venueblockedid',
    'address',
    'maxcapacity',
    'starttime',
    'endtime',
  ],

  methods: {
    selectedResourceTest() {
      // console.log(this.id, this.venuename, this.$data);

      const venueObject = {
        venuename: this.venuename,
        venueid: this.id,
        venueblockedid: this.venueblockedid,
        address: this.address,
        maxcapacity: this.maxcapacity,
        starttime: this.starttime,
        endtime: this.endtime,
      };

      this.$emit('booking-confirmed', venueObject);
    },
  },
};
</script>

<style scoped>
li {
  margin: auto;
  max-width: 50rem;
}

.button-item {
  border: 2px solid rgb(228, 227, 227);

  margin-right: 0.5rem;
  border-left: dashed;
  border-left-color: gray;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

button:hover {
  background-color: #77b4e6cb;
  border-top-right-radius: 9px;
  border-bottom-right-radius: 9px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

h3 {
  font-size: 1.25rem;
  margin: 0.5rem 0;
}
b {
  color: #fff;
}

p {
  margin: 0.5rem 0;
}

a {
  text-decoration: none;
  color: #ce5c00;
}

a:hover,
a:active {
  color: #c89300;
}

.fade-enter-active {
  transition: opacity 0.5s ease-in-out;
}

.fade-enter-from {
  opacity: 0;
}
</style>
